import { useDroppable } from '@dnd-kit/core';
import { Stack } from '@mui/material';
import { FC, ReactNode } from 'react';

export type UnassignedDropAreaProps = {
  children: ReactNode;
};

/**
 * 車両 row → 未割当リストへのドロップ受け口。Presenter#handleDragEnd は overId === 'unassigned' で
 * ロウ→未割当の処理を行うので、このパネル全体を droppable として登録する。
 *
 * Why not リスト本体（ConvenienceDispatchUnassignedList）で useDroppable を呼ぶ: useDroppable は
 * dnd-kit の InternalContext を useContext で購読するので、呼んだコンポーネントはドロップ先が
 * 変わるたびに再描画される（memo では避けられない）。1400 行のリスト本体で呼ぶと、絞り込み・
 * 並べ替えの導出と全アイテムの再生成まで毎回やり直しになる。ここは ref と outline だけを持ち、
 * 本体は children として受け取る（children の要素参照が変わらなければ、このコンポーネントが
 * isOver で再描画されても React は children のサブツリーを描き直さない）。
 */
export const UnassignedDropArea: FC<UnassignedDropAreaProps> = ({ children }) => {
  const { setNodeRef, isOver } = useDroppable({ id: 'unassigned' });
  return (
    <Stack
      ref={setNodeRef}
      spacing={0}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        // ドラッグ中にドロップ可能であることを視覚化
        outline: isOver ? '2px solid hsl(var(--primary) / 0.5)' : 'none',
        outlineOffset: -2,
        transition: 'outline-color 150ms',
      }}
    >
      {children}
    </Stack>
  );
};
